import { render, staticRenderFns } from "./Xband.vue?vue&type=template&id=15aab380&scoped=true&"
import script from "./Xband.vue?vue&type=script&lang=js&"
export * from "./Xband.vue?vue&type=script&lang=js&"
import style0 from "./Xband.vue?vue&type=style&index=0&id=15aab380&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aab380",
  null
  
)

export default component.exports